import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { CHECKOUT_URL, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
const INCLUDED = ['6 professional welding inspection modules', '5 practical weld inspection bonuses', 'Weld joint geometry and configuration diagrams', 'Weld discontinuity identification references', 'Visual testing and measurement procedures', 'NDT methods and indication comparisons', 'Weld quality evaluation and code navigation', 'Inspection reports and practical case studies'];
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-white py-5 sm:py-7" data-id="element-121" data-mp="yy7tu0hnnt2f">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-122" data-mp="z0aqh3dbckg4">
        <p className="mx-auto w-fit rounded-md bg-gold px-3 py-1 font-display text-xs font-extrabold uppercase tracking-widest text-navy sm:text-sm" data-id="element-123" data-mp="2fb4v2hcxsbz7">
          SPECIAL LAUNCH OFFER
        </p>

        <div className="mt-2 overflow-hidden rounded-2xl border-[3px] border-dashed border-tech bg-white shadow-lg" data-id="element-124" data-mp="pj5ssivaq8bd">
          <div className="bg-navy p-3 text-center sm:p-5" data-id="element-125" data-mp="uhqs8g2q4nyr">
            <h2 className="text-3xl leading-none text-white sm:text-5xl" data-id="element-126" data-mp="zhvcmh6r62u9">🔍 {PRODUCT}</h2>
            <p className="mx-auto mt-1 max-w-2xl font-display text-xs font-bold uppercase leading-tight tracking-wide text-gold sm:text-base" data-id="element-127" data-mp="13jq9n9hnhu28">
              {PRODUCT_TAGLINE}
            </p>
          </div>

          <div className="grid gap-3 p-3 sm:p-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-6" data-id="element-128" data-mp="bsaqjpfaypgr">
            <MockupImage data-id="element-129" data-mp="ftvyqxgw6fkm" />

            <div data-id="element-130" data-mp="ftm95azreafg">
              <p className="font-heading text-xl uppercase leading-tight text-navy sm:text-2xl" data-id="element-131" data-mp="ft4geocb2eca">
                Complete 6-in-1 Professional Welding Inspection Visual System
              </p>
              <ul className="mt-1.5 grid gap-1" data-id="element-132" data-mp="3k845hztzjsvp">
                {INCLUDED.map(item => <li key={item} className="flex items-start gap-2" data-id="element-133" data-mp="3o8o65ddrpeml">
                    <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-tech" aria-hidden="true" data-id="element-134" data-mp="veyz4kly52yr" />
                    <span className="text-sm font-medium leading-snug text-steel sm:text-base" data-id="element-135" data-mp="155k6awforfta">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-3 rounded-xl border-2 border-gold bg-gold-soft px-3 py-2 text-center" data-id="element-136" data-mp="cgmo0tbh5j0j">
                <p className="font-display text-sm font-extrabold uppercase leading-tight text-navy sm:text-lg" data-id="element-137" data-mp="7ibfqn0tvgkf">
                  🔥 GET {PRODUCT} TODAY —{' '}
                  <span className="whitespace-nowrap font-heading text-4xl font-normal text-tech sm:text-5xl" data-id="element-138" data-mp="lfgj2f95q1bz">
                    $27 USD
                  </span>
                </p>
              </div>

              <div className="mt-3 flex flex-col items-center" data-id="element-139" data-mp="1wykn2eznajgu">
                <CTAButton href={CHECKOUT_URL} data-id="element-140" data-mp="1sucwec9mmtfz">🔍 GET INSTANT ACCESS</CTAButton>
                <TrustLine items={['Immediate Digital Access', '🛡️ 7-Day Money-Back Guarantee']} data-id="element-141" data-mp="20edzfas66fso" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}